import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asset-control-rooms',
  templateUrl: './asset-control-rooms.component.html',
  styleUrls: ['./asset-control-rooms.component.scss']
})
export class AssetControlRoomsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
